import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-line border-t-brand-green" />
      </div>
    );
  }
  if (!user) return <Navigate to="/site-settings/login" replace />;
  return children;
}
